import { render } from "./AppInstallDetails.vue?vue&type=template&id=f3145dac"
import script from "./AppInstallDetails.vue?vue&type=script&lang=js"
export * from "./AppInstallDetails.vue?vue&type=script&lang=js"

import exportComponent from "/builds/oclc-top/academic-library-services/shared-services/mobileapps/app-install-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__